<div class="fx-row align-items-center justify-content-between">
  <div class="fx-column">
    <span class="page-title">{{'DOCUMENTS_LIST.TITLE' | translate}}</span>
    <span class="page-subtitle">{{'DOCUMENTS_LIST.SUBTITLE' | translate}}</span>
  </div>
  <div class="fx-row align-items-center justify-content-end">
    <button class="button main-bg mr-10 white"
            *ngIf="selection && selection.selected && selection.selected.length > 0"
            (click)="downloadDocuments()">
      <mat-icon class="dark mr-5 white" fontSet="material-icons-outlined">file_download</mat-icon>
      <span class="white">
        {{ 'ACTIONS.DOWNLOAD' | translate }} {{ selection.selected.length }} {{
          ((selection.selected.length > 1
            ? 'ENTITIES.DOCUMENTS'
            : 'ENTITIES.DOCUMENT') | translate).toLowerCase()
        }}
      </span>
    </button>
    <div class="danger-button" *ngIf="selection && selection.selected && selection.selected.length > 0"
      (click)="deleteDocuments()">
      {{ 'ACTIONS.DELETE' | translate}} {{selection.selected.length}} {{((selection.selected.length > 1 ?
      'ENTITIES.DOCUMENTS' :
      'ENTITIES.DOCUMENT') | translate).toLowerCase()}}
    </div>
    <button class="button ml-10" (click)="toBatches()">
      {{'DOCUMENTS_LIST.UPLOADS_HISTORY' | translate}}
    </button>
    <app-quota-bound-button quota="volume" *ngIf="!loading && done && !noDocs">
      <button class="main-button ml-20" (click)="upload()" aclBasedElement resource="DOCUMENT" [scopes]="['C']">
        <div class="fx-row align-items-center justify-content-center">
          <mat-icon class="white mr-5" fontSet="material-icons-outlined">cloud_upload</mat-icon>
          {{'ACTIONS.UPLOAD' | translate}}
        </div>
      </button>
    </app-quota-bound-button>
  </div>
</div>

<mat-divider class="mv-20"></mat-divider>
<mat-card *ngIf="!loading && done && !noDocs" class="p-0">
  <app-documents-filter-drawer [displayMode]="displayMode" [levels]="levels" [count]="count"
    [(filters)]="documentService.filters" (filtersChange)="onFilterChange()">

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" *ngIf="!loading && done && !noDocs"
      (selectedTabChange)="onTabChange($event)" class="mt-20">
      <mat-tab>
        <ng-template mat-tab-label class="text">
          {{ 'DOCUMENTS_LIST.DISPLAY_MODE_LIST' | translate }}
        </ng-template>
        <ng-template matTabContent>
          <app-documents-table [filteredDocuments]="filteredDocuments" [pager]="documentService.pager"
            (sort)="onSortChange($event)" (page)="handlePage($event)" (reload)="reload()" [select]="true"
            [(selection)]="selection" />
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label class="text">
          {{ 'DOCUMENTS_LIST.DISPLAY_MODE_REPORT' | translate }}
        </ng-template>
        <ng-template matTabContent>
          <app-documents-report #documentsReport [filters]="documentService.filters" />
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label class="text">
          {{ 'DOCUMENTS_LIST.DISPLAY_MODE_HIERARCHY' | translate }}
        </ng-template>
        <ng-template matTabContent>
          <app-documents-hierarchy [first]="levels[1]" [second]="levels[2]" [third]="levels[3]" />
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </app-documents-filter-drawer>
</mat-card>

<app-empty-placeholder *ngIf="!loading && done && noDocs" class="fx-flex" [offset]="125"
  [title]="'DOCUMENTS_LIST.NO_DOCUMENTS'" [message]="'DOCUMENTS_LIST.NO_DOCUMENTS_MESSAGE'"
  [button]="noDocumentButton"></app-empty-placeholder>
